export const SYNC_CHANGES = '@player/sync-changes';
export const CLEAR_PLAYER = '@player/clear-player';

export const START = '@player/start';
export const RESTART = '@player/restart';
export const PAUSE = '@player/pause';
